import { Component } from "@angular/core";

@Component({
    selector: "kno2-callback",
    template: ""
})
export class CallbackComponent {}
